.ux-iws-teaser-sidebar-icon {
    display: block;
    padding: 5px 0 25px;
    margin-bottom: 15px;
    max-width: 100%;

    &__wrapper {
        display: flex !important;

        > ux-icon {
            font-size: 50px;
            margin-right: 20px;
        }
    }

    /* stylelint-disable max-nesting-depth */
    &__wrapper--content-element {
        @media (max-width: 1023px) {
            flex-direction: column;
            align-items: center;
            text-align: center;
            word-wrap: break-word;

            ux-icon {
                margin-right: 0;
                margin-bottom: 20px;
            }
        }
    }
    /* stylelint-enable max-nesting-depth */

    &__text-content {
        display: flex;
        flex-direction: column;
        align-self: stretch;
        justify-content: space-evenly;
        max-width: 100%;
    }

    &__text-content > [slot="title"] {
        margin-bottom: 0;

        @media only screen and (min-width: 1440px) {
            font-size: 18px;
        }
    }
}
